import request from '../base-service';
import type { InternalAxiosRequestConfig } from 'axios';
import type { ApiResponse } from '@/types/base';
import type {
  KPIConsecutiveFailDismissRequest,
  KPIConsecutiveFailScanRequest,
  KPIConsecutiveFailScanResponse,
} from '@/types/kpi-consecutive-fail';

const API_BASE = '/v1/kpiconsecutivefail';

function unwrapData<T>(res: unknown): T {
  const anyRes = res as any;
  return (anyRes?.data?.data ?? anyRes?.data ?? anyRes) as T;
}

export const kpiConsecutiveFailApi = {
  scan: async (model: KPIConsecutiveFailScanRequest): Promise<KPIConsecutiveFailScanResponse> => {
    const res = await request.post<ApiResponse<KPIConsecutiveFailScanResponse>>(
      `${API_BASE}/scan`,
      model,
      { authorization: true } as InternalAxiosRequestConfig
    );
    return unwrapData<KPIConsecutiveFailScanResponse>(res);
  },

  list: async (model: KPIConsecutiveFailScanRequest): Promise<KPIConsecutiveFailScanResponse> => {
    const res = await request.post<ApiResponse<KPIConsecutiveFailScanResponse>>(
      `${API_BASE}/list`,
      model,
      { authorization: true } as InternalAxiosRequestConfig
    );
    return unwrapData<KPIConsecutiveFailScanResponse>(res);
  },

  dismiss: async (model: KPIConsecutiveFailDismissRequest): Promise<boolean> => {
    const res = await request.post<ApiResponse<boolean>>(
      `${API_BASE}/dismiss`,
      {
        id: model.id,
        lyDo: model.lyDo,
        phanHe: model.phanHe ?? 'bsc',
      },
      { authorization: true } as InternalAxiosRequestConfig
    );
    const data = unwrapData<boolean | { success?: boolean }>(res);
    if (typeof data === 'boolean') return data;
    return !!(data as any)?.success || !!(res as any)?.data?.success;
  },
};
